export class ExtractZipSuccessEffect {
  public static readonly type =
    '[Project/Storage/List] ExtractZipSuccessEffect';
  constructor(public readonly folder: string) {}
}
